import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface Role {
  id: string;
  name: string;
  permissions: string[];
  organisationId: string;
  createdAt: Date;
  updatedAt: Date | null;
  userCount: number;
  isDefault: boolean;
}

export const useGetRoles = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Role[]>([QueryEntity.Roles], async () => {
    const response = await fetch(`${APIBaseChronos}/api/roles`, fetchConfigGET);
    if (!response.ok) {
      throw new Error('Failed to fetch roles');
    }
    return response.json();
  });
};
